<script>
import breadcrumbs from "@/components/breadcrumbs.vue";
import btns from "@/components/btns.vue";
import CustomModal from "@/components/customModal.vue";

export default {
  name: "teamPerformanceManage",
  components: { CustomModal, btns, breadcrumbs },
  provide() {
    return { modalData: this.modalData };
  },
  data() {
    return {
      pickerOptionsEnd: {
        disabledDate: time => {
          let beginDateVal = this.form.startTime;
          if (beginDateVal) {
            return (
              time.setHours(0, 0, 0, 0) <
              new Date(beginDateVal).setHours(0, 0, 0, 0)
            );
          } else {
            return time.getTime() < Date.now() - 8.64e7;
          }
        }
      },
      form: {
        startTime: null,
        endTime: null
      },
      modalData: {}
    };
  },
  methods: {
    //表格序号，根据索引+1
    indexMethod(index) {
      return index + 1;
    },
    exec(fun) {
      if (this[fun]) {
        this.funTit = fun;
        this[fun]();
      } else {
        this.$message.error("方法未定义");
      }
    },
    search() {
      this.$refs.customTable.search();
    },
    reset() {
      this.$refs.customTable.search();
    },
    /**
     * 设置
     */
    setting() {
      this.$refs.settingModal.open("编辑");
    },
    /**
     * 新增团队
     */
    addTeam() {
      this.$router.push({
        path: "/staff/teamperformance/teamPerformanceAdd"
      });
    },
    /**
     * 详情
     * @param row
     */
    detail(row = {}) {
      this.$router.push({
        path: "/staff/teamperformance/teamPerformanceDetail",
        query: {
          id: row.id
        }
      });
    },
    /**
     * 并入
     * @param row
     */
    mergeInto(row) {
      Object.assign(this.modalData, row || {});
      this.$refs.mergeIntoModal.open("并入团队");
    },
    /**
     * 冻结
     * @param row
     */
    freeze(row) {
      Object.assign(this.modalData, row || {});
      this.$refs.freezeModal.open("冻结团队");
    },
    /**
     * 解散
     * @param row
     */
    dissolve(row) {
      Object.assign(this.modalData, row || {});
      this.$refs.dissolveModal.open("解散团队");
    },
    /**
     * 脱离
     * @param row
     */
    detach(row) {
      Object.assign(this.modalData, row || {});
      this.$refs.detachModal.open("脱离团队");
    }
  }
};
</script>

<template>
  <div>
    <!-- 面包屑 -->
    <breadcrumbs></breadcrumbs>
    <!-- 表单查询 -->
    <div class="pdt-15 pdb-15 bg-white">
      <el-form ref="form" :model="form" label-width="90px" inline>
        <el-form-item label="团队名称">
          <el-input
            v-model="form.userName"
            placeholder="请输入团队名称"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="管理者姓名">
          <el-select
            v-model="form.status"
            placeholder="请输入或选择管理者姓名"
            clearable
            filterable
          >
            <el-option label="正常" :value="0"></el-option>
            <el-option label="冻结" :value="1"></el-option>
            <el-option label="锁定" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="团队类型">
          <el-select
            v-model="form.status"
            placeholder="请选择团队类型"
            clearable
          >
            <el-option label="正常" :value="0"></el-option>
            <el-option label="冻结" :value="1"></el-option>
            <el-option label="锁定" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="团队状态">
          <el-select
            v-model="form.status"
            placeholder="请选择团队状态"
            clearable
          >
            <el-option label="正常" :value="0"></el-option>
            <el-option label="冻结" :value="1"></el-option>
            <el-option label="锁定" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="创建时间">
          <el-date-picker
            v-model="form.startTime"
            format="yyyy-MM-dd"
            type="date"
            placeholder="开始日期"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
          至
          <el-date-picker
            v-model="form.endTime"
            :picker-options="pickerOptionsEnd"
            format="yyyy-MM-dd"
            type="date"
            placeholder="结束日期"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="search">查 询 </el-button>
          <el-button @click="reset">重 置 </el-button>
          <el-button type="primary" @click="">导出 </el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="flex mgt-20">
      <div>
        团队总数 <span style="font-weight: bold;font-size: 16px">20</span>
      </div>
      <div class="tip mgl-20">
        温馨提示:&nbsp;&nbsp;数据来源于社区售水机+楼宇机
      </div>
    </div>
    <btns @exec="exec" class="mgb-20"></btns>
    <!-- 统计 -->
    <div class="flex aic jcsb mgt-20 mgb-20">
      <div class="flex aic fw-600 color0063ea">
        <span class="mgr-50">订单总数(笔)：</span>
        <span class="mgr-50">总充值金额(实付/赠送)：</span>
        <span class="mgr-50">总提成(元)：</span>
      </div>
      <div class="flex aic">
        <div>选择团队</div>
        <el-select
          v-model="form.status"
          placeholder="选择团队"
          clearable
          style="margin-left: 20px"
        >
          <el-option label="正常" :value="0"></el-option>
          <el-option label="冻结" :value="1"></el-option>
          <el-option label="锁定" :value="2"></el-option>
        </el-select>
      </div>
    </div>
    <el-button type="text" size="small" @click="detail({ id: 1111 })"
      >脱离
    </el-button>
    <customTable
      ref="customTable"
      :api="undefined"
      :params="form"
      :isMounted="false"
    >
      <template #columns>
        <el-table-column
          type="index"
          :index="indexMethod"
          label="序号"
          width="50"
          fixed="left"
        >
        </el-table-column>
        <el-table-column prop="partnerNum" label="团队名称"></el-table-column>
        <el-table-column prop="userName" label="团队类型"></el-table-column>
        <el-table-column prop="partnerNum" label="管理者姓名"></el-table-column>
        <el-table-column prop="userName" label="成员数量"></el-table-column>
        <el-table-column prop="partnerNum" label="状态"></el-table-column>
        <el-table-column prop="userName" label="订单数（笔）"></el-table-column>
        <el-table-column
          prop="partnerNum"
          label="充值金额(实付/赠送)"
        ></el-table-column>
        <el-table-column
          prop="userName"
          label="充值提成（元）"
        ></el-table-column>
        <el-table-column prop="partnerNum" label="创建时间"></el-table-column>
        <el-table-column fixed="right" label="操作" width="120">
          <template #default="{row}">
            <el-button type="text" size="small" @click="detail(row)"
              >详情
            </el-button>
            <el-button type="text" size="small" @click="mergeInto(row)"
              >并入
            </el-button>
            <el-button type="text" size="small" @click="freeze(row)"
              >冻结
            </el-button>
            <el-button type="text" size="small" @click="dissolve(row)"
              >解散
            </el-button>
            <el-button type="text" size="small" @click="detach(row)"
              >脱离
            </el-button>
          </template>
        </el-table-column>
      </template></customTable
    >
    <customModal
      ref="settingModal"
      path="views/teamperformance/components/setting"
      center
      :footer="false"
    >
    </customModal>
    <!--    并入团队-->
    <customModal
      ref="mergeIntoModal"
      path="views/teamperformance/components/mergeInto"
      center
      :showCancelButton="false"
      width="360px"
    >
    </customModal>
    <!--    脱离团队-->
    <customModal
      ref="detachModal"
      path="views/teamperformance/components/detach"
      center
      :showCancelButton="false"
      width="360px"
    >
    </customModal>
    <customModal
      ref="freezeModal"
      center
      :showCancelButton="false"
      width="360px"
    >
      团队被冻结后，
      <div style="color: var(--danger)">团队无法恢复正常</div>
      ，数据将会保留，成员可加入其他团队，是否确认冻结团队?
    </customModal>
    <customModal
      ref="dissolveModal"
      center
      :showCancelButton="false"
      width="360px"
    >
      团队被解散后<span style="color: var(--danger);">团队无法恢复</span
      >，数据将不会保留，成员可加入其他团队，是否确认解散团队?
    </customModal>
  </div>
</template>

<style scoped lang="scss">
.tip {
  color: var(--danger);
}
</style>
